import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import ".//styles/global.css";
import "@mdi/font/css/materialdesignicons.css";
import axios from "axios";

Vue.config.productionTip = false;
Vue.prototype.$api = process.env.VUE_APP_BACKEND_API;

// Restaura token salvo ao recarregar a página
const token = localStorage.getItem("ft_admin_token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

// Redireciona para /login quando o backend retornar 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("ft_admin_token");
      localStorage.removeItem("ft_admin_nome");
      delete axios.defaults.headers.common["Authorization"];
      if (router.currentRoute.name !== "login") {
        router.push({ name: "login" });
      }
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
